function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "forward");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "forward",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Arrow-Blazing--Right",
  transform: "translate(25.000000, 25.000000) scale(-1, 1) translate(-25.000000, -25.000000) translate(10.000000, 11.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(15.000000, 14.000000) scale(-1, 1) rotate(-90.000000) translate(-15.000000, -14.000000) translate(1.000000, -1.000000)",
  id: "Rectangle"
}, React.createElement("path", {
  d: "M1.06332797,19.0517114 L16.2238592,19.1943285 C17.2224458,19.2037223 18.0282585,20.0135654 18.0326883,21.0121864 C18.0370735,22.0088855 17.2364545,22.8224174 16.2398125,22.8339605 L1.06328233,23.0097355 C-0.0284948785,23.0223804 -0.923805967,22.1475709 -0.936583541,21.0557937 C-0.936583541,21.0481621 -0.936583541,21.0405301 -0.936583541,21.0328979 C-0.936583541,19.9386704 -0.0495368521,19.0516237 1.04469069,19.0516237 C1.05090322,19.0516237 1.05711571,19.0516237 1.06332797,19.0517114 Z",
  transform: "translate(8.548052, 21.030747) rotate(45.000000) translate(-8.548052, -21.030747) "
}), React.createElement("path", {
  d: "M12.2046173,18.880654 L27.0845335,19.253902 C28.0502135,19.2781251 28.8293378,20.0514418 28.8607853,21.0169135 C28.8908831,21.9409505 28.1662022,22.7144298 27.2421651,22.7445276 C27.2267992,22.7450281 27.2114271,22.7453169 27.1960532,22.7453939 L12.2052211,22.8205093 C11.1061844,22.8259889 10.2107763,21.9395064 10.2052462,20.8404696 C10.2052462,20.837147 10.2052462,20.8338244 10.2052462,20.8305017 C10.2052462,19.7532918 11.0784973,18.8800406 12.1557073,18.8800406 C12.1720125,18.8800406 12.1883171,18.8802451 12.2046173,18.880654 Z",
  transform: "translate(19.533468, 20.850275) scale(-1, 1) rotate(45.000000) translate(-19.533468, -20.850275) "
}), React.createElement("path", {
  d: "M3.99999975,10.0002342 L23.9999998,10.0025739 C25.1046071,10.0027031 25.9999998,10.8982005 25.9999998,12.0028078 C25.9999998,13.1072481 25.104674,14.0025739 24.0002337,14.0025739 C24.0001558,14.0025739 24.0000777,14.0025739 23.9999998,14.0025739 L3.99999975,14.0002342 C2.8953924,14.000105 1.99999975,13.1046076 1.99999975,12.0000003 C1.99999975,10.89556 2.89532551,10.0002342 3.9997658,10.0002342 C3.99984378,10.0002342 3.99992176,10.0002342 3.99999975,10.0002342 Z",
  transform: "translate(14.000000, 12.001404) scale(-1, 1) rotate(90.000000) translate(-14.000000, -12.001404) "
}))));

var SvgForward = function SvgForward(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgForward, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/forward.02878a76.svg";
export { ForwardRef as ReactComponent };